import { animateScroll as scroll } from 'react-scroll'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import styled from 'react-emotion';

import DetailHeader from './DetailHeader/DetailHeader';
import DetailBody from './DetailBody/DetailBody';
import { fetchEvent } from '../../redux/actions/events';
import Spinner from '../../components/Spinner/Spinner';

const DetailContainer = styled('div')`
  flex-direction: column;
  display: flex;
  min-height: 100%;
`;

const SpinnerContainer = styled('div')`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
`;

class Detail extends Component {
  static propTypes = {
    events: PropTypes.arrayOf(PropTypes.object),
  };

  static defaultProps = {
    events: [],
  };

  componentDidMount() {
    this.props.fetchEvent(this.eventId)
  }

  render() {
    scroll.scrollToTop({ duration: 0 });

    const { event } = this.props;
    if (!event) return Detail.spinner;

    return (
      <DetailContainer>
        <DetailHeader
          imageUrl={event.poster.url}
          location={event.location}
          title={event.title}
        />
        <DetailBody
          allDay={event.allDay}
          description={event.description}
          endDateTime={event.endDateTime}
          location={event.location}
          startDateTime={event.startDateTime}
        />
      </DetailContainer>
    )
  }

  static get spinner() {
    return (
      <SpinnerContainer>
        <Spinner message="Fetching event..." />
      </SpinnerContainer>
    );
  }

  get eventId() {
    return this.props.match.params.id || 1;
  }
}

export default connect(
  state => ({
    event: state.firestore.data.event,
  }),
  { fetchEvent },
)(Detail);



// WEBPACK FOOTER //
// ./src/views/Detail/Detail.js